// extracted by mini-css-extract-plugin
export default {"headerWrapper":"styles_headerWrapper__XrnIq","contentWrapper":"styles_contentWrapper__BTg4B","logoWrapper":"styles_logoWrapper__MuDqm"};